module.exports = __webpack_public_path__ + "static/media/barnard.ff5795be.png";